import { ArticleSummary, Cta1, CtaSmall } from "@/components/CtaBlocks";
import { Builder } from "@builder.io/react";
import { buttonStyle, allowedFileTypes, registerMenuGroups, commonInputs } from "./helper";

const ctaBlocks = [
  {
    name: "CTA Blocks",
    items: [
      { name: "CTA Small" },
      { name: "Article Summary" }
    ]
  },
];

const ctaSections = [
  {
    name: "CTA Sections",
    items: [
      { name: "CTA 1" }
    ]
  },
];

export const registerCtaComponents = () => {
  registerMenuGroups(ctaBlocks);
  registerMenuGroups(ctaSections);

  // CTA Blocks
  Builder.registerComponent(CtaSmall, {
    name: "CTA Small",
    friendlyName: "CTA Small",
    noWrap: true,
    inputs: [
      {
        name: "extraSpaceAtBottom",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "ctaStyle",
        type: "string",
        enum: ["bordered", "background"],
        defaultValue: "bordered",
      },
      {
        name: "title",
        type: "text",
      },
      {
        name: "hasSubtitle",
        type: "boolean",
        defaultValue: false,
      },
      {
        name: "subtitle",
        type: "text",
        showIf: `options.get('hasSubtitle') === true`,
      },
      {
        name: "alwaysStackButtons",
        type: "boolean",
        defaultValue: false,
      },
      ...commonInputs.buttonInputs({
        excludeMicroCopy: true,
      }),
      ...commonInputs.secondaryButtonInputs(),
    ],
  });

  //Cta Sections
  Builder.registerComponent(Cta1, {
    name: "CTA 1",
    friendlyName: "CTA 1",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      {
        name: "ctaTitle",
        type: "text",
        defaultValue: "Helping clients find the right finance?",
      },
      {
        name: "ctaSubtitle",
        type: "text",
        defaultValue: "Earn industry-leading commissions and rewards as you provide your clients with the work capital solutions they need to grow.",
      },
      {
        name: "ctaButtonText",
        type: "text",
        defaultValue: "Become a partner",
      },
      {
        name: "ctaButtonLink",
        type: "url",
        defaultValue: "/partners",
      },
      {
        name: "ctaButtonStyle",
        type: "string",
        enum: buttonStyle,
        defaultValue: "brand",
      },
      {
        name: "ctaImage",
        type: "file",
        allowedFileTypes: allowedFileTypes,
      },
      {
        name: "ctaImageAltText",
        type: "text",
        defaultValue: "CTA Image",
      },
      {
        name: "subscribeFormTitle",
        type: "text",
        defaultValue: "Subscribe for the latest business Insights",
      },
      {
        name: "subscribeFormSubtitle",
        type: "text",
        defaultValue: "Get expert tips, industry updates, and exclusive insights straight to your inbox.",
      },
      {
        name: "subscribeFormButtonText",
        type: "text",
        defaultValue: "Subscribe",
      },
    ],
  });

  Builder.registerComponent(ArticleSummary, {
    name: "Article Summary",
    noWrap: true,
    inputs: [
      {
        name: "summaryType",
        type: "string",
        enum: ["market-insights", "case-studies", "business-guides"],
        required: true,
      },
      {
        name: "caseStudies",
        type: "object",
        showIf: `options.get('summaryType') === 'case-studies'`,
        subFields: [
          {
            name: "hasCompanyLogo",
            type: "boolean",
            defaultValue: true,
          },
          ...commonInputs.imageInput({
            name: "companyLogo",
            includeAltText: true,
            showIf: `options.get('hasCompanyLogo') === true`,
          }),
          {
            name: "companyProfile",
            type: "longText",
            required: true,
          },
          {
            name: "challenge",
            type: "longText",
          },
          {
            name: "showIndustry",
            type: "boolean",
            defaultValue: true,
          },
          {
            name: "companySize",
            type: "text",
          },
          {
            name: "showProducts",
            type: "boolean",
            defaultValue: true,
          },
        ],
      },
      {
        name: "marketInsights",
        type: "object",
        showIf: `options.get('summaryType') === 'market-insights'`,
        subFields: [
          {
            name: "showDate",
            type: "boolean",
            defaultValue: true,
          },
          {
            name: "overrideDate",
            type: "boolean",
            defaultValue: false,
            showIf: `options.get('showDate') === true`,
          },
          {
            name: "Date",
            type: "date",
            defaultValue: "",
            showIf: `options.get('overrideDate') === true`,
          },
          {
            name: "showAuthor",
            type: "boolean",
            defaultValue: true,
          },
          {
            name: "showReviewer",
            type: "boolean",
            defaultValue: true,
          },
          {
            name: "showTopics",
            type: "boolean",
            defaultValue: true,
          },
        ],
      },
      {
        name: "businessGuides",
        type: "object",
        showIf: `options.get('summaryType') === 'business-guides'`,
        subFields: [
          {
            name: "showDate",
            type: "boolean",
            defaultValue: true,
          },
          {
            name: "overrideDate",
            type: "boolean",
            defaultValue: false,
            showIf: `options.get('showDate') === true`,
          },
          {
            name: "Date",
            type: "date",
            defaultValue: "",
            showIf: `options.get('overrideDate') === true`,
          },
          {
            name: "showAuthor",
            type: "boolean",
            defaultValue: true,
          },
          {
            name: "showTopics",
            type: "boolean",
            defaultValue: true,
          },
        ],
      },
    ],
  });

  
};

